export const CONTACTS = [
  {
    title: '衛生局醫政科',
    groups: ['居家醫療', '到宅牙醫', '行動護理', '行動復能'],
    contact: '(08) 737-0002 分機138'
  },
  {
    title: '衛生局食品藥物管理科',
    groups: ['行動藥師'],
    contact: '(08) 737-0002 分機171至177'
  },
  {
    title: '衛生局心理衛生與毒品防制科',
    groups: ['行動心理師'],
    contact: '(08) 737-0002 分機191至194'
  },
  {
    title: '衛生局保健科',
    groups: ['行動營養師'],
    contact: '(08) 737-0002 分機151至155'
  },
  {
    title: '長期照護處',
    groups: [
      '屏東分站', '萬丹鄉', '九如分站', '高樹分站', '鹽埔分站', '萬巒分站', '崁頂分站', '南州分站', '琉球分站', '恆春分站',
      '車城分站', '枋山分站', '滿州分站', '獅子分站', '牡丹分站', '霧台分站', '瑪家分站', '泰武分站', '春日分站', '來義分站',
      '三地門分站'
    ],
    contacts: [
      '(08)735-1010', '(08)766-2900', '(08)739-6799', '(08)796-0222', '(08)793-0396', '(08)781-1700', '(08)863-2102',
      '(08)864-1318', '(08)861-3034', '(08)889-2199', '(08)882-1688分機11~14', '(08)876-1861', '(08)880-1567',
      '(08)877-1535', '(08)883-1083', ' (08)790-2605', '(08)799-5011', '(08)783-6002', '(08)878-5945', ' (08)785-1113',
      '(08)799-2261'
    ]
  },
];